import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
    reducer: {}
});

export default store;